import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, withModifiers as _withModifiers, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76148e26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Einstellungen", -1))
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "card-title" }, "Persönliche Daten", -1))
const _hoisted_5 = {
  key: 0,
  class: "success"
}
const _hoisted_6 = {
  key: 1,
  class: "error-banner"
}
const _hoisted_7 = ["onSubmit"]
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "settings-first-name" }, "Vorname *", -1))
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "settings-last-name" }, "Nachname *", -1))
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "card" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "card-title" }, "Organisation", -1))
const _hoisted_15 = {
  key: 0,
  class: "org-current"
}
const _hoisted_16 = {
  key: 1,
  class: "org-current"
}
const _hoisted_17 = {
  key: 3,
  class: "org-hint"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "card-title" }, "Abmelden", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "org-hint" }, "Meldet Sie auf diesem Gerät von der Lernplattform ab.", -1))

import { ref, reactive, computed, watch } from "vue";
import { useRouter } from "vue-router";
import { Auth } from "aws-amplify";
import { store } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsView',
  setup(__props) {

const router = useRouter();
const form = reactive({ first_name: "", last_name: "" });
const saving = ref(false);
const successMsg = ref<string | null>(null);
const saveError = ref<string | null>(null);

const user = computed(() => store.getters.getUser);
const currentOrganisation = computed(
  () => store.getters["organisation/getOrganisation"]
);
const hasMultipleOrgs = computed(() => {
  const all = store.getters["organisation/getAllOrganisation"];
  return Array.isArray(all) && all.length > 1;
});

watch(
  user,
  (u) => {
    if (u) {
      form.first_name = u.first_name || "";
      form.last_name = u.last_name || "";
    }
  },
  { immediate: true }
);

// Für den „Organisation wechseln"-Button die Mitgliedschaften nachladen (gecacht)
store.dispatch("organisation/FETCH_ALL").catch(() => undefined);

const valid = computed(
  () => form.first_name.trim().length > 0 && form.last_name.trim().length > 0
);

async function save() {
  if (!valid.value) return;
  saving.value = true;
  successMsg.value = null;
  saveError.value = null;
  try {
    await store.dispatch("saveUser", {
      first_name: form.first_name.trim(),
      last_name: form.last_name.trim(),
      consentGiven: user.value?.consentGiven ?? false,
    });
    successMsg.value = "Ihre Daten wurden gespeichert.";
  } catch (e) {
    saveError.value = "Speichern fehlgeschlagen. Bitte versuchen Sie es erneut.";
  } finally {
    saving.value = false;
  }
}

function logout() {
  localStorage.removeItem("organisationId");
  Auth.signOut();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (successMsg.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(successMsg.value), 1))
        : _createCommentVNode("", true),
      (saveError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(saveError.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        onSubmit: _withModifiers(save, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            id: "settings-first-name",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.first_name) = $event)),
            type: "text",
            class: "input",
            autocomplete: "given-name"
          }, null, 512), [
            [_vModelText, form.first_name]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            id: "settings-last-name",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.last_name) = $event)),
            type: "text",
            class: "input",
            autocomplete: "family-name"
          }, null, 512), [
            [_vModelText, form.last_name]
          ])
        ]),
        _createElementVNode("button", {
          class: "btn btn-primary",
          type: "submit",
          disabled: saving.value || !_unref(valid)
        }, _toDisplayString(saving.value ? "Wird gespeichert …" : "Speichern"), 9, _hoisted_12)
      ], 40, _hoisted_7)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      (_unref(currentOrganisation))
        ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
            _createTextVNode(" Sie arbeiten aktuell in "),
            _createElementVNode("strong", null, _toDisplayString(_unref(currentOrganisation).name), 1),
            _createTextVNode(". ")
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_16, "Aktuell ist keine Organisation ausgewählt.")),
      (_unref(hasMultipleOrgs) || !_unref(currentOrganisation))
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "btn btn-secondary",
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/organisationen')))
          }, " Organisation wechseln "))
        : (_openBlock(), _createElementBlock("p", _hoisted_17, " Sie sind Mitglied in einer Organisation. "))
    ]),
    _createElementVNode("div", { class: "card" }, [
      _hoisted_18,
      _hoisted_19,
      _createElementVNode("button", {
        class: "btn btn-secondary",
        type: "button",
        onClick: logout
      }, "Abmelden")
    ])
  ]))
}
}

})